import React from "react";
import { AlertTriangle, CheckCircle2, Info } from "lucide-react";
import { useI18n } from "../i18n";

export const CbamRulesBanner = ({ sum }) => {
  const { t } = useI18n();
  if (!sum) return null;
  if (sum.regime !== "definitive") {
    return (
      <div data-testid="cbam-regime-banner" className="mb-6 flex items-center gap-2 rounded-xl border border-[#e4e6dd] bg-[#fafbf6] px-4 py-3 text-sm text-[#4b544c]">
        <Info className="h-4 w-4" />{t("regimeTransitional")}
      </div>
    );
  }
  const over = sum.threshold_exceeded;
  const priceLabel = sum.price_status === "official" ? t("priceOfficial") : t("priceEstimated");
  return (
    <div data-testid="cbam-regime-banner" className="mb-6 grid grid-cols-1 gap-3 rounded-xl border border-[#dfe8dc] bg-[#f3f8f1] p-4 text-sm text-[#1b2420] md:grid-cols-4">
      <div><div className="text-xs text-[#6b7268]">{t("regimeDefinitive")}</div>
        <div data-testid="cbam-cert-price" className="font-semibold">{t("certPrice")}: €{sum.eu_price?.toFixed(2)} <span className="text-xs font-normal text-[#6b7268]">({priceLabel})</span></div></div>
      <div><div className="text-xs text-[#6b7268]">{t("cbamFactorLbl")}</div>
        <div data-testid="cbam-factor" className="font-semibold">{((sum.cbam_factor || 0) * 100).toFixed(1)}%</div></div>
      <div><div className="text-xs text-[#6b7268]">{t("thresholdLbl")} · {sum.annual_mass_t} t</div>
        <div data-testid="cbam-threshold" className={`flex items-center gap-1 font-semibold ${over ? "text-[#b4541a]" : "text-[#2f8f5b]"}`}>
          {over ? <AlertTriangle className="h-4 w-4" /> : <CheckCircle2 className="h-4 w-4" />}{over ? t("thresholdOver") : t("thresholdUnder")}
        </div></div>
      <div><div className="text-xs text-[#6b7268]">{t("deadlineLbl")}</div>
        <div data-testid="cbam-deadline" className="font-semibold">{sum.declaration_deadline}</div></div>
    </div>
  );
};
